/**
 * The common "elevated stat-card" surface — a subtle top→bottom gradient, an
 * inset top-edge highlight, and a stronger border so the card lifts off the
 * muted tray it sits on (flat in light, a faint lift in dark).
 *
 * This is the single source of truth for the stat / metric card variant that
 * originated on the Working tab (cooking now / on deck / late paused /
 * unassigned). Compose it with each card's own layout + padding:
 *
 *   cn(statCardSurface, "flex flex-col gap-3 p-4", className)
 *
 * Keep the surface here only — radius, border, background and shadow. Layout,
 * padding and sizing belong to the consuming component.
 */
export const statCardSurface =
  "overflow-hidden rounded-xl border border-(--color-border-strong) bg-[linear-gradient(180deg,var(--color-surface-content-top),var(--color-surface-content))] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]";
